import React from 'react';
import { Link as ScrollLink } from 'react-scroll';
import { string } from 'prop-types';

import './scroll-button.scss';

const ScrollButton = ({ scrollTo, title }) => {
  return (
    <ScrollLink
      smooth
      duration={1000}
      to={scrollTo}
      offset={-300}
      className='scroll__btn'
    >
      {title}
    </ScrollLink>
  );
};

ScrollButton.propTypes = {
  scrollTo: string.isRequired,
  title: string.isRequired,

};

export default ScrollButton;
